export default {
  props: ['imgSrc'],
  methods: {
    bigImg: function bigImg() {
      // 发送事件
      this.$emit('clickit');
    }
  }
};